import { createContext as e } from "react";
//#region src/components/applicationLayout/ApplicationLayoutContext.ts
var t = e("application");
//#endregion
export { t as default };

//# sourceMappingURL=ApplicationLayoutContext.js.map